<!-- libs/features/global-search/feature-global-search/src/lib/components/result-items/usergroup-result-item/usergroup-result-item.component.html -->

@if (item()) {
	<!-- Main container -->
	<div class="item-container">
		<!-- Header row: Name and Member Count -->
		<div class="flex justify-between items-center">
			<!-- Group Name and Icon -->
			<span class="font-semibold text-purple-600 flex items-center">
				<!-- Use icon from metadata or default -->
				<icon [icon]="item().metadata?.icon || 'fas fa-users'" class="mr-2 ml-2 text-gray-500" />
				{{ item().name || 'שם קבוצה לא זמין' }}
			</span>

			<!-- Member Count -->
			<span class="text-gray-500">
				<!-- Access usersCount calculated in the entity -->
				{{ item().usersCount || 0 }} חברים
				<!-- Example: Add group type if available (not directly in UserGroup model) -->
				<!-- | סוג: {{ item().type || 'לא ידוע' }} -->
			</span>
		</div>

		<!-- Description -->
		@if (item().description) {
			<p class="text-gray-600 mt-1">
				{{ item().description }}
			</p>
		}

		<!-- Status (Locked/Unlocked) -->
		<div class="text-gray-500 mt-1">
			סטטוס:
			@if (item().locked) {
				<span class="text-red-600">
					<icon [icon]="'fas fa-lock'" class="mr-1 ml-1" />
					נעול
				</span>
			} @else {
				<span class="text-green-600">
					<!-- Optional: You could add an 'unlocked' icon if desired -->
					<!-- <icon [icon]="'fas fa-lock-open'" class="mr-1 ml-1" /> -->
					לא נעול
				</span>
			}
		</div>
	</div>
} @else {
	<!-- Optional: Placeholder -->
	<div class="p-4 border rounded-md animate-pulse bg-gray-100">
		<div class="flex justify-between items-center mb-2">
			<div class="h-4 bg-gray-300 rounded w-1/2"></div>
			<div class="h-3 bg-gray-300 rounded w-1/4"></div>
		</div>
		<div class="h-3 bg-gray-300 rounded w-full mb-1"></div>
		<div class="h-3 bg-gray-300 rounded w-3/4"></div>
	</div>
}
